import Reacr, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import PropTypes from 'prop-types';
import formatMoney from '../../../../utils/functions/formatMoneyBRL';
import Information from '../../../../components/Information/InformationColum';
import { theme } from '../../../../styles/theme';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const { secondaryColor } = theme.colors;

export default function TaxCollum() {
  const { TAXAS } = useSelector((state) => state.user.usersData);
  const [expanded, setExpanded] = useState(false);

  const data = TAXAS?.map((taxa) => {
    switch (taxa.ID_TIPO_VALOR) {
      case '1':
        return {
          name: taxa.DESCRICAO,
          value: `R$ ${formatMoney(taxa.VALOR)}`,
        };
      case '2':
        return {
          name: taxa.DESCRICAO,
          value: `${formatMoney(taxa.VALOR)} %`,
        };
      default:
        return {
          name: taxa.DESCRICAO,
          value: `${parseInt(taxa.VALOR)}`,
        };
    }
  });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      expanded={expanded === 'panel1'}
      onChange={handleChange('panel1')}
      sx={{
        width: '100%',
        boxShadow: '0',
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          bgcolor: 'rgb(236, 239, 240)',
          borderRadius: '5px',
          paddingTop: '0.4rem',
        }}
      >
        <Typography sx={{ flexShrink: 0 }}>
          <h1
            style={{
              fontFamily: 'Poppins',
              fontWeight: 600,
              fontStyle: 'normal',
              fontSize: '1.389vw',
              lineHeight: '2.083vw',
            }}
          >
            Visualizar Taxas Aplicadas
          </h1>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Styled.TaxaContainer>
          <Information
            // title="Taxas Aplicadas"
            data={data}
            color={secondaryColor}
            bold={true}
          />
        </Styled.TaxaContainer>
      </AccordionDetails>
    </Accordion>
  );
}
